import { channelTypes } from '@/modules/campaign-manage/enum/Labels'
import { inAppTypes } from '@/modules/campaign-manage/enum/InAppTypesEnum'
import { onsiteTypes } from '@/modules/campaign-manage/enum/OnsiteTypesEnum'

const fields = Object.freeze({
  [channelTypes.email]: {
    default: [
      'email_subject',
      'email_from_name',
      'email_reply_to_name',
      'email_template'
    ]
  },
  [channelTypes.ios_push]: {
    default: ['push_title', 'push_text']
  },
  [channelTypes.android_push]: {
    default: ['push_title', 'push_text']
  },
  [channelTypes.web_push]: {
    default: ['push_title', 'push_text']
  },
  [channelTypes.inapp]: {
    [inAppTypes.HTML]: ['inapp.html'],
    [inAppTypes.MODAL]: [
      'inapp.editor.title',
      'inapp.editor.main_text',
      'inapp.editor.button0.text',
      'inapp.editor.button1.text'
    ]
  },
  [channelTypes.onsite]: {
    [onsiteTypes.ALERT]: ['push_title', 'push_text'],
    [onsiteTypes.POPUP]: [
      'onsite.popup.button0.text',
      'onsite.popup.button1.text',
      'onsite.popup.title',
      'onsite.popup.main_text',
      'onsite.popup.footer'
    ]
  }
})

export { fields }



// WEBPACK FOOTER //
// ./src/modules/campaign-manage/enum/ImportExportFields.js